var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 419.157,
    viewBox: "0 0 350 419.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(1000.4 1077.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M328.568,269.045H21.432A21.432,21.432,0,0,1,0,247.613V46.7a21.431,21.431,0,0,1,21.432-21.43H328.568A21.431,21.431,0,0,1,350,46.7V247.613a21.432,21.432,0,0,1-21.432,21.432",
    transform: "translate(-1000.399 -961.361)",
    fill: "#feade7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 5.659,
    cy: 5.659,
    r: 5.659,
    transform: "matrix(0.526, -0.851, 0.851, 0.526, -988.179, -917.28)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 5.659,
    cy: 5.659,
    r: 5.659,
    transform: "matrix(0.526, -0.851, 0.851, 0.526, -969.134, -917.28)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 5.659,
    cy: 5.659,
    r: 5.659,
    transform: "matrix(0.526, -0.851, 0.851, 0.526, -950.089, -917.28)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M293.1,168.809a20.308,20.308,0,0,0-1.657-26.268,20.774,20.774,0,0,0,2.756-1.157,20.421,20.421,0,0,0-.518-36.214c-.041-.021-.09-.031-.131-.052A20.3,20.3,0,0,0,282.7,69.286a20.562,20.562,0,0,0,1.361-2.646,20.314,20.314,0,0,0-23.815-27.284A20.342,20.342,0,0,0,228.9,18.787a20.307,20.307,0,0,0-36.434-8.533,20.339,20.339,0,0,0-37.2,4.4,20.356,20.356,0,0,0-33.445,16.884A20.395,20.395,0,0,0,94.857,46.588a20.219,20.219,0,0,0,1.335,12.3A20.328,20.328,0,0,0,81.458,93.334,20.353,20.353,0,0,0,79.215,130.7c.041.02.09.031.131.052A20.31,20.31,0,0,0,90.2,166.588a20.276,20.276,0,0,0,22.454,29.93A20.341,20.341,0,0,0,144,217.086a20.307,20.307,0,0,0,36.434,8.534,20.339,20.339,0,0,0,37.2-4.4,20.354,20.354,0,0,0,33.432-16.889,20.4,20.4,0,0,0,26.98-15.042,20.239,20.239,0,0,0-1.337-12.3,20.329,20.329,0,0,0,16.4-8.172",
    transform: "translate(-983.81 -967.527)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M291.436,42.045V148.9a13.777,13.777,0,0,0,13.777,13.777h221.75A13.777,13.777,0,0,0,540.739,148.9V122.523h30a7.474,7.474,0,0,0,6.473-11.212L540.739,72.045v-30a13.777,13.777,0,0,0-13.777-13.777H305.213a13.777,13.777,0,0,0-13.777,13.777",
    transform: "translate(-1291.835 -1105.674)",
    fill: "#ff7bac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M321.792,237.563,310.32,204.6a76.436,76.436,0,0,0-72.191-51.315H98.372A76.438,76.438,0,0,0,27,202.357L13.5,237.563",
    transform: "translate(-997.104 -930.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M321.792,237.563,310.32,204.6a76.436,76.436,0,0,0-72.191-51.315H98.372A76.438,76.438,0,0,0,27,202.357L13.5,237.563",
    transform: "translate(-997.104 -930.116)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M144.323,53.373c-22.377,21.541-21.963,58.355.924,82.227s59.582,25.761,81.958,4.22,21.963-58.354-.924-82.227-59.581-25.761-81.958-4.22",
    transform: "translate(-969.206 -958.161)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M104.736,202.275h0a47.681,47.681,0,0,0,67.3-4.257l70.23-79.721L192.34,74.312,103.052,175.665a18.854,18.854,0,0,0,1.683,26.611",
    transform: "translate(-976.396 -949.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M104.736,202.275h0a47.681,47.681,0,0,0,67.3-4.257l70.23-79.721L192.34,74.312,103.052,175.665A18.854,18.854,0,0,0,104.736,202.275Z",
    transform: "translate(-976.396 -949.39)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M167.648,85.7a41.627,41.627,0,0,1,48.525-15.56h0a41.61,41.61,0,0,1,24.9,53.317l-1.569,4.321a9.028,9.028,0,0,1-6.133,16.879L227.9,159.722A41.61,41.61,0,0,1,149.68,131.3l4.71-12.963-6.385-5.659A16.764,16.764,0,0,1,167.648,85.7",
    transform: "translate(-965.654 -951.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M167.648,85.7a41.627,41.627,0,0,1,48.525-15.56h0a41.61,41.61,0,0,1,24.9,53.317l-1.569,4.321a9.028,9.028,0,0,1-6.133,16.879L227.9,159.722A41.61,41.61,0,0,1,149.68,131.3l4.71-12.963-6.385-5.659A16.764,16.764,0,0,1,167.648,85.7Z",
    transform: "translate(-965.654 -951.022)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M155.163,88.671a10.528,10.528,0,0,1-.208,11.47",
    transform: "translate(-962.58 -945.886)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M191.584,139.022s-7.974-.012-8.585-10.776",
    transform: "translate(-955.735 -936.227)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M214.037,113.508c-1.131,2.039-3.415,2.935-5.1,2s-2.139-3.347-1.008-5.386,3.414-2.935,5.1-2,2.139,3.347,1.008,5.386",
    transform: "translate(-949.803 -941.229)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M218.176,101.181c-.052,1.459-3.37,2.523-7.411,2.377s-7.273-1.448-7.219-2.906,3.37-2.524,7.411-2.377,7.273,1.447,7.219,2.906",
    transform: "translate(-950.72 -943.545)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M206.783,36.056a73.846,73.846,0,0,0-77.9,21.124A17.872,17.872,0,0,0,143.9,64.1a18.228,18.228,0,0,0-.839,2.5A18.011,18.011,0,0,0,167.6,87.323a18.035,18.035,0,0,0,30.227,13.823,18,18,0,0,0,33.075,2.593,18.017,18.017,0,0,0,26.954,1.451,73.856,73.856,0,0,0-51.069-69.133",
    transform: "translate(-968.942 -959.609)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M115.293,225.1h-16.6L109.4,214.069a24.66,24.66,0,0,1,15.587-7.393c5.265-.45,7.971,1.436,11.8,7.794L155.479,248.1l-7.889,1.449a16.363,16.363,0,0,1-15.179-5.215Z",
    transform: "translate(-976.312 -917.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M115.293,225.1h-16.6L109.4,214.069a24.66,24.66,0,0,1,15.587-7.393c5.265-.45,7.971,1.436,11.8,7.794L155.479,248.1l-7.889,1.449a16.363,16.363,0,0,1-15.179-5.215Z",
    transform: "translate(-976.312 -917.1)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M97.738,225.1h-16.6l10.705-11.031a24.66,24.66,0,0,1,15.587-7.393,11.4,11.4,0,0,1,11.8,7.794L134,257.259l-10.932.561A14.37,14.37,0,0,1,109.533,250Z",
    transform: "translate(-980.596 -917.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M97.738,225.1h-16.6l10.705-11.031a24.66,24.66,0,0,1,15.587-7.393,11.4,11.4,0,0,1,11.8,7.794L134,257.259l-10.932.561A14.37,14.37,0,0,1,109.533,250Z",
    transform: "translate(-980.596 -917.096)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M80.183,225.1h-16.6l10.706-11.031a24.66,24.66,0,0,1,15.587-7.393,11.4,11.4,0,0,1,11.8,7.794l13.346,39.155-10.932.561a14.37,14.37,0,0,1-13.534-7.816Z",
    transform: "translate(-984.881 -917.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M80.183,225.1h-16.6l10.706-11.031a24.66,24.66,0,0,1,15.587-7.393,11.4,11.4,0,0,1,11.8,7.794l13.346,39.155-10.932.561a14.37,14.37,0,0,1-13.534-7.816Z",
    transform: "translate(-984.881 -917.096)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M63.5,225.1H46.9l10.706-11.031A24.66,24.66,0,0,1,73.2,206.671,11.4,11.4,0,0,1,85,214.465l11.187,33.974L85.253,249a14.37,14.37,0,0,1-13.534-7.817Z",
    transform: "translate(-988.952 -917.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M63.5,225.1H46.9l10.706-11.031A24.66,24.66,0,0,1,73.2,206.671,11.4,11.4,0,0,1,85,214.465l11.187,33.974L85.253,249a14.37,14.37,0,0,1-13.534-7.817Z",
    transform: "translate(-988.952 -917.096)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M350.277,98.455s4.938,4.68,17.587-2.535,22.528-26.662,13.407-30.074c-22.587-8.447-18.314,28.546,13.079,36.909S450.6,80.9,448.841,71.493c-2.064-11.011-18.033-18.547-26.478-6.046-9.646,14.278,22.954,46.268,46.4,42.1s23.313-17.562,22.273-23.856-6.214-13.214-10.884-12.5c-11.118,1.7-16.418,22.224,35.445,22.508",
    transform: "translate(-1302.407 -1098.183)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.87ebebbeb362d85a9d2683525eab2547.svg";
export { ForwardRef as ReactComponent };